import React, { useEffect, useState } from "react";
import verticalSpacing from "utils/generate-vertical-spacing";
import SkeletonSections from "components/loader/skeleton-sections";
import { useCustomer } from "hooks/useStore";
import clsx from "clsx/lite";

import "styles/rewards.mod.scss";

// Components
import ReferFriend from "components/refer-friend";
import BannerImage from "components/loyalty-lion/banner-image";
import TierBenefits from "components/loyalty-lion/tier-benefits";
import ReferFriendBanner from "components/loyalty-lion/refer-friend-banner";
import HistoryTable from "components/loyalty-lion/history-table";
import ClaimedRewardsList from "components/loyalty-lion/claimed-rewards-list";
import RewardsList from "components/loyalty-lion/rewards-list";
import LoyaltyRulesList from "components/loyalty-lion/rules-list";
import LoyaltySteps from "components/loyalty-lion/steps";

const _module2Component = {
	loyaltyBannerImage: BannerImage,
	referFriend: ReferFriend,
	tierBenefits: TierBenefits,
	referFriendBanner: ReferFriendBanner,
	historyTable: HistoryTable,
	claimedRewardsList: ClaimedRewardsList,
	rewardsList: RewardsList,
	rulesList: LoyaltyRulesList,
	loyaltyLionSteps: LoyaltySteps,
};

const LoyaltyLion = ({ data }) => {
	const [loading, setLoading] = useState(true);
	const { isAuthenticated } = useCustomer(["isAuthenticated"]);

	useEffect(() => {
		window.loyaltylion?.ui?.refresh();
	}, [loading]);

	useEffect(() => {
		setLoading(isAuthenticated === undefined);
	}, [isAuthenticated]);

	if (loading) return <SkeletonSections />;

	return data?.components?.map((component) => {
		const RequestedModule = _module2Component[component._type];
		if (component.settings?.isHidden) return null;

		return RequestedModule ? (
			<div key={component._key}
				style={{ backgroundColor: component.settings?.bgColor?.hex }}
				className={clsx("w-full ll-rewards", verticalSpacing(component.settings?.verticalSpace))}>
				<div className={clsx(component.settings?.isFluid ? "w-full" : "standard-section-width mx-auto")}>
					<RequestedModule data={component} />
				</div>
			</div>
		) : null;
	});
};

export default LoyaltyLion;